/*
 * @Author: lidan
 * @Date: 2020-12-10 14:20:58
 * @LastEditTime: 2020-12-14 09:54:02
 * @LastEditors: lidan
 * @Description: 送货员管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\delivery.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 送货员管理 ****************** */

//获取送货员管理列表数据
export function listDeliveries(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/listDeliveries`,
    method: "post",
    data
  });
}
//新增送货员信息
export function insertDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/insertDelivery`,
    method: "post",
    data
  });
}
//修改送货员信息
export function updateDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/updateDelivery`,
    method: "post",
    data
  });
}

//查询送货员详细信息
export function findDeliveryById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/findDeliveryById`,
    method: "get",
    params
  });
}
//删除送货员信息
export function deleteDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/deleteDelivery`,
    method: "post",
    data
  });
}

//送货员姓名、手机号唯一性校验
export function validateDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/validateDelivery`,
    method: "post",
    data
  });
}

//送货员导出信息
export function exportDeliveries(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/exportDeliveries`,
    method: "post",
    data
  });
}

//查询送货员历史记录列表
export function listHistoryDeliveries(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/listHistoryDeliveries`,
    method: "post",
    data
  });
}

//车辆下拉
export function getVehicleInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/vehicleInfo/getPageByCondition`,
    method: "post",
    data
  });
}

//送货员下拉
export function findAllDelivery(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/delivery/findAllDelivery`,
    method: "post",
    data
  });
}
